
import React, { useContext, useState } from 'react';
import NewLeadsHistogram from 'components/dashboard/NewLeadsHistogram';
import EmailsHistogram from 'components/dashboard/TokenUsageHistogram';
import EmailTypeBarChart from 'components/dashboard/EmailTypeBarChart';
import FinishedTasksHistogram from 'components/dashboard/FinishedTasksHistogram';
import { Row, Col, CardBody, Card } from "reactstrap";
import IconButtonWithTooltip from 'components/buttons/IconButtonWithTooltip';
import { faCalendar, faChartLine, faClipboardCheck, faDisplay, faInbox, faLightbulb, faList} from '@fortawesome/free-solid-svg-icons';
import ProjectSuggestions from 'components/dashboard/ProjectSuggestions';
import EmbeddedList from 'components/common/EmbeddedList';
import { OBJ } from 'constants';
import TodoCalendarFrame from 'components/modules/todos/TodoCalendarFrame';
import DocumentCaptureButton from 'components/buttons/DocumentCaptureButton';
import { UserSettingsContext } from 'contexts/UserSettingsContext';
import { useTranslation } from 'react-i18next';

const viewOptions = [
    { id: OBJ.TODOS_KANBAN, label: 'button.kanban', icon: faClipboardCheck},
    { id: OBJ.TODOS, label: 'button.list', icon: faList},
    { id: OBJ.TODOS_CALENDAR, label: 'button.calendar', icon: faCalendar},
];

function Dashboard(props) {
    const { t } = useTranslation();
    const [view, setView] = useState(OBJ.TODOS_KANBAN);
    const [diagramView, setDiagramView] = useState(true);
    const [isMaximized, setIsMaximized] = useState(false);
    const [isMaximizedScreen, setIsMaximizedScreen] = useState(false);

    const toggleMaximize = () => {
        setIsMaximized(!isMaximized);
    };
    
    return (
        <div className="content">
            <Row>
                <DocumentCaptureButton obj={OBJ.CUSTOMERS} />
                <Col lg="12" xl={isMaximizedScreen ? "12" : "7"}>
                    {view === OBJ.TODOS_CALENDAR ?
                        <TodoCalendarFrame/>
                    :
                        <EmbeddedList type={OBJ.TODOS} context={{type: OBJ.TODOS}} view={view}/>
                    }
                    {viewOptions.filter(option => option.id != view).map(item =>
                        <IconButtonWithTooltip key={item.id} translationId={item.label} icon={item.icon} onClick={()=> setView(item.id)} type="Button"/>
                    )}
                    {/*<IconButtonWithTooltip translationId={diagramView ? 'button.inspiration' : 'button.diagram'} icon={diagramView ? faLightbulb : faChartLine} onClick={()=> setDiagramView(!diagramView)} type="Button"/>*/}
                    <IconButtonWithTooltip translationId={isMaximizedScreen ? 'button.inspiration' : 'button.diagram'} icon={isMaximizedScreen ? faInbox : faDisplay} onClick={()=> setIsMaximizedScreen(!isMaximizedScreen)} type="Button"/>
                </Col>
                <Col lg="12" xl={isMaximizedScreen ? "12" : "5"}>
                    {diagramView ?
                        <>
                            <Row>
                                <Col xs="12">
                                    <NewLeadsHistogram/>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={isMaximizedScreen ? "6" : "12"}>
                                    <EmailsHistogram isMaximized={isMaximized} toggleMaximize={toggleMaximize} />
                                </Col> 
                                <Col lg={isMaximizedScreen ? "6" : "12"}>
                                    <EmailTypeBarChart/>
                                </Col>
                                <Col lg="12">
                                    <FinishedTasksHistogram/>
                                </Col>
                            </Row>
                        </> 
                    : 
                        <ProjectSuggestions setlistView={setView}/>
                    }
                </Col>
            </Row>
        </div>
    );
}

export default Dashboard;
